import React, { useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import styled from "styled-components";
import ArrowIcon from "assets/images/CalenderArrowIcon.png";
import { toast } from "react-toastify";
import _ from "lodash";
import { useSelector } from "react-redux";

moment.locale("en-GB");
const localizer = momentLocalizer(moment);

export default function CalendarSection({ convertedData, campaignData }) {
  const modifiedCampaigns = [];
  let pendingCampId = 0;
  const { siteSettingsData } = useSelector((state) => state.commonReducers);
  campaignData?.campaigns?.forEach((c) => {
    const obj = {
      ...c,
      publishInfo: campaignData?.publishInfo,
      tournPublishInfo: campaignData?.tournPublishInfo,
    };
    modifiedCampaigns.push(obj);
  });

  ///################SORTING THROUGH ICONS START#################////

  function compareDates(dateA, dateB) {
    if (!dateA && dateB) return -1;
    if (dateA && !dateB) return 1;
    if (dateA < dateB) return -1;
    if (dateA > dateB) return 1;
    return 0;
  }

  function findPendingCampaign() {
    // Get list of all scheduled non-tournament campaigns that include today in their date range
    let now = moment.utc();
    let list = _.filter(convertedData, function (campaign) {
      if (
        campaign?.startDateUtc &&
        campaign?.endDateUtc &&
        !campaign?.tournamentId
      ) {
        let start = moment.utc(campaign?.startDateUtc);
        if (now.isAfter(start)) {
          let end = moment.utc(campaign?.endDateUtc).add(1, "d");
          if (end.isAfter(now)) {
            return true;
          }
        }
      }
      return false;
    });

    if (list.length > 0) {
      // one or more span today
      // Sort to prioritize based on this logic:
      //    if start dates differ, select campaign with later start date
      //    else select campaign with earlier end date
      list.sort(function (a, b) {
        if (compareDates(a?.startDateUtc, b?.startDateUtc) !== 0)
          return compareDates(b?.startDateUtc, a?.startDateUtc);
        return compareDates(a?.endDateUtc, b?.endDateUtc);
      });
      pendingCampId = list[0]?.Id;
    } else {
      // No scheduled campaigns include today, select base campaign
      let def = _.find(convertedData, function (campaign) {
        return campaign?.startDateUtc === null; // base campaign has NULL start/end dates
      });
      if (def) pendingCampId = def?.Id;
      else pendingCampId = 0; // jic
    }
  }

  findPendingCampaign();

  const currentlyPublished = (campaign) => {
    if (campaign?.tournamentId) {
      if (campaign?.tournPublishInfo) {
        if (
          campaign?.baseVersion === campaign?.tournPublishInfo.version &&
          campaign?.lastModifiedUtc < campaign?.tournPublishInfo.publishedUtc
        ) {
          return true;
        }
      }
    } else {
      if (campaign?.publishInfo) {
        if (
          campaign?.baseVersion === campaign?.publishInfo.version &&
          campaign?.lastModifiedUtc < campaign?.publishInfo.publishedUtc
        ) {
          return true;
        }
      }
    }
    return false;
  };

  const publishedButModified = (campaign) => {
    if (campaign.tournamentId) {
      if (campaign.tournPublishInfo) {
        if (
          campaign.baseVersion === campaign.tournPublishInfo.version &&
          campaign.lastModifiedUtc > campaign.tournPublishInfo.publishedUtc
        ) {
          return true;
        }
      }
    } else {
      if (campaign.publishInfo) {
        if (
          campaign.baseVersion === campaign.publishInfo.version &&
          campaign.lastModifiedUtc > campaign.publishInfo.publishedUtc
        ) {
          return true;
        }
      }
    }
    return false;
  };

  const pendingPublish = (campaign) => {
    if (campaign?.tournamentId) {
      if (campaign?.tournPublishInfo) {
        let now = new moment.utc();
        let start = moment.utc(campaign?.startDateUtc);
        if (now.isAfter(start)) {
          let end = moment.utc(campaign?.endDateUtc).add(1, "d");
          if (end.isAfter(now)) {
            if (
              campaign?.tournPublishInfo?.publishedUtc <
                campaign?.lastModifiedUtc ||
              campaign?.baseVersion !== campaign?.tournPublishInfo?.version
            )
              return (
                campaign?.welcomeAd &&
                campaign?.welcomeAd?.imageId !== 0 &&
                campaign?.fbAd &&
                campaign?.fbAd?.imageId !== 0
              );
          }
        }
      }
    } else {
      if (campaign.Id === pendingCampId && !currentlyPublished(campaign))
        return (
          campaign?.welcomeAd &&
          campaign?.welcomeAd?.imageId !== 0 &&
          campaign?.fbAd &&
          campaign?.fbAd?.imageId !== 0
        );
    }
    return false;
  };

  const pendingPublishButCant = (campaign) => {
    if (campaign.tournamentId) {
      if (campaign.tournPublishInfo) {
        let now = new moment.utc();
        let start = moment.utc(campaign.startDateUtc);
        if (now.isAfter(start)) {
          let end = moment.utc(campaign.endDateUtc).add(1, "d");
          if (end.isAfter(now)) {
            if (
              campaign.tournPublishInfo.publishedUtc <
                campaign.lastModifiedUtc ||
              campaign.baseVersion !== campaign.tournPublishInfo.version
            )
              return (
                (campaign.welcomeAd && campaign.welcomeAd.imageId === 0) ||
                (campaign.fbAd && campaign.fbAd.imageId === 0)
              );
          }
        }
      }
    } else {
      if (
        campaign.Id === campaign.pendingCampaignId &&
        !currentlyPublished(campaign)
      )
        return (
          (campaign.welcomeAd && campaign.welcomeAd.imageId === 0) ||
          (campaign.fbAd && campaign.fbAd.imageId === 0)
        );
    }
    return false;
  };
  //   ///################SORTING THROUGH ICONS END #################////

  const getEventStatus = (data) => {
    let status = "";
    if (currentlyPublished(data)) {
      status = "CP";
    } else if (publishedButModified(data)) {
      status = "PBM";
    } else if (pendingPublish(data)) {
      status = "PP";
    } else if (pendingPublishButCant(data)) {
      status = "PPBC";
    } else {
      status = "";
    }
    return status;
  };

  // event for adding label on calendar
  const events = modifiedCampaigns.map((data) => {
    return {
      id: data.Id,
      title: data.Description,
      start: new Date(
        moment
          .utc(data.startDateUtc)
          .utcOffset(-siteSettingsData?.TimeZoneOffset)
          .format("ddd DD-MMM-YYYY")
      ),
      end: new Date(
        moment
          .utc(data.endDateUtc)
          .utcOffset(-siteSettingsData?.TimeZoneOffset)
          .format("ddd DD-MMM-YYYY")
      ),
      resource: getEventStatus(data),
    };
  });

  const onEventClick = React.useCallback((event) => {
    toast({
      message: event.title,
    });
  }, []);

  const view = React.useMemo(() => {
    return {
      calendar: { popover: true, count: true },
    };
  }, []);

  const getLinearGradientByStatus = (status) => {
    if (status === "CP") {
      return "linear-gradient(90deg, #00A692 50.43%, rgba(0, 166, 146, 0) 99.57%)";
    } else if (status === "PBM") {
      return "linear-gradient(90deg, #8DD6FF 50%, rgba(141, 214, 255, 0) 99.35%)";
    } else if (status === "PP") {
      return "linear-gradient(90deg, #FFE500 50%, rgba(234, 181, 45, 0) 103.39%)";
    } else if (status === "PPBC") {
      return "linear-gradient(90deg, #FA3C30 50%, rgba(250, 60, 48, 0) 97.83%)";
    }
    return "linear-gradient(90deg, rgba(0,0,0,1) 0%, rgba(49,116,173,1) 0%, rgba(255,255,255,1) 100%)";
  };

  const eventStyleGetter = (event) => {
    var style = {
      background: getLinearGradientByStatus(event.resource),
      borderRadius: "0px",
      opacity: 1,
      color: "#ffffff",
      border: "0px",
      display: "block",
      fontSize: "8px",
      lineHeight: "9px",
      padding: "3px 5px",
    };
    return {
      style: style,
    };
  };
  return (
    <Container>
      <Calendar
        maxDate={new Date()}
        views={["month"]}
        selectable
        localizer={localizer}
        defaultDate={new Date()}
        defaultView="month"
        events={events}
        onEventClick={(e) => onEventClick(e, events)}
        onView={view}
        popup
        eventPropGetter={(e) => eventStyleGetter(e, events)}
      />
    </Container>
  );
}

const Container = styled.div`
  min-width: 60.2%;

  .rbc-off-range-bg {
    background: white;
    z-index: 10;
  }
  /* .rbc-toolbar-label {
    font-size: 12px;
  } */
  .rbc-header {
    padding: 5px 3px;
    font-weight: normal;
    background: #bbb2a5;
    font-weight: 500;
  }
  .rbc-header + .rbc-header {
    border: none;
  }
  .rbc-btn-group {
    width: 156px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    button {
      :nth-child(1) {
        display: none;
      }
      :nth-child(2),
      :nth-child(3) {
        background-image: url(${ArrowIcon});
        background-repeat: no-repeat;
        font-size: 1px;
        color: #fff;
        padding: 5px;
        border: none;
        background-position: center;
      }
      :nth-child(3) {
        transform: rotate(180deg);
      }
    }
  }
  .rbc-toolbar {
    position: relative;
    margin: 0;
    padding: 4px 0;
    font-weight: 500;
    background: var(--box-header-background);
  }
  .rbc-row {
    .rbc-date-cell {
      text-align: left;
      padding-left: 10px;
      color: #455997;
      font-size: 14px;
      :first-child {
        color: #ff5353;
      }
    }
  }
`;
